import React, { useState, useMemo, useCallback } from 'react';
import { ProductsFilters } from '@/hooks/queries/useProducts';
import { useDebounce } from '@/hooks/useDebounce';
import ProductsHeader from '@/components/products/ProductsHeader';
import ProductsFiltersBar from '@/components/products/ProductsFilters';
import ProductsContent from '@/components/products/ProductsContent';
import PageBackground from '@/components/common/PageBackground';

const ProductsPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearch = useDebounce(searchQuery, 500);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | undefined>();

  const filters: ProductsFilters = useMemo(
    () => ({
      limit: 12,
      categoryId: selectedCategoryId === 'all' ? undefined : selectedCategoryId,
      search: debouncedSearch || undefined,
    }),
    [selectedCategoryId, debouncedSearch],
  );

  const handleClearFilters = useCallback(() => {
    setSearchQuery('');
    setSelectedCategoryId(undefined);
  }, []);

  const hasActiveFilters = !!(selectedCategoryId || searchQuery);

  return (
    <PageBackground>
      {/* Header */}
      <ProductsHeader />

      {/* Filters */}
      <ProductsFiltersBar
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        selectedCategoryId={selectedCategoryId}
        onCategoryChange={setSelectedCategoryId}
        hasActiveFilters={hasActiveFilters}
        onClearFilters={handleClearFilters}
      />

      {/* Products Content */}
      <ProductsContent filters={filters} hasActiveFilters={hasActiveFilters} onClearFilters={handleClearFilters} />
    </PageBackground>
  );
};

export default ProductsPage;
